import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { agentChecklistAPI } from '@/lib/api';
import { CheckCircle2, Circle, Rocket } from 'lucide-react';

export function GettingStartedChecklist({ npn }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!npn) return;
    agentChecklistAPI.gettingStarted(npn)
      .then(res => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [npn]);

  if (loading || !data) return null;
  // Hide once 100% complete to avoid noise
  if (data.progress >= 100) return null;

  return (
    <Card data-testid="getting-started-checklist">
      <CardContent className="p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="h-9 w-9 rounded-lg bg-sky-100 flex items-center justify-center">
            <Rocket size={16} className="text-sky-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-heading font-semibold text-slate-900">Getting Started</p>
            <div className="flex items-center gap-2 mt-1">
              <div className="flex-1 h-2 rounded-full bg-slate-100 overflow-hidden">
                <div
                  className="h-full bg-sky-500 transition-all"
                  style={{ width: `${data.progress}%` }}
                />
              </div>
              <span className="text-xs font-medium text-slate-600">{data.progress}%</span>
            </div>
          </div>
        </div>
        <ul className="space-y-1.5">
          {data.items.map(item => (
            <li key={item.key} className="flex items-center gap-2 text-sm" data-testid={`checklist-${item.key}`}>
              {item.done ? (
                <CheckCircle2 size={14} className="text-emerald-500 shrink-0" />
              ) : (
                <Circle size={14} className="text-slate-300 shrink-0" />
              )}
              <span className={item.done ? 'text-slate-400 line-through' : 'text-slate-700'}>{item.label}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}

export default GettingStartedChecklist;
